import type { GlobalCollectionId } from '#layers/data-model/types/schema/ids';

// TODO generate these out in the engine
export const WorkspaceCollectionIds = {
	MonospaceFile: '19eb534d-129a-4525-abf6-1d894a442a5c' as GlobalCollectionId,
} as const;
